import repository from '@/repositories/Repository'

const resource = '/api/tapir-md'

export default {
  get(id, queryParam) {
    return repository.http
      .get(`${resource}/${id}/tana-power-excel?${queryParam}`, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(r => r.data)
  },
}
